import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

const StyledBox = styled(Box)(({ height }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  background:
    'linear-gradient(180deg, rgba(86,86,86,0.57) 0%, rgba(216,216,216,0) 100%)',
  height
}));

function GradientOverlay({ height }) {
  return <StyledBox height={height} />;
}

GradientOverlay.propTypes = {
  height: PropTypes.string.isRequired
};

export default GradientOverlay;
